import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React from 'react';
import { useTabsContext } from './tabs-context.esm.js';
import { TAB_THEME_KEY } from './types.esm.js';
import { transitions } from '../../themes/theme-keys/transitions.esm.js';
import { BoxPrivate } from '../_primitives/box/box.esm.js';

var _excluded = ["variant", "className", "orientation", "indicatorPosition", "disableAnimation", "height", "width", "backgroundColor"];
var ArrowIndicator = /*#__PURE__*/React.forwardRef(function ArrowIndicator(props, ref) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'indicator' : _props$variant,
    className = props.className,
    orientation = props.orientation;
    props.indicatorPosition;
    var disableAnimation = props.disableAnimation,
    _props$height = props.height,
    height = _props$height === void 0 ? '0.5em' : _props$height,
    _props$width = props.width,
    width = _props$width === void 0 ? '0.5em' : _props$width,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? 'white' : _props$backgroundColo,
    other = _objectWithoutProperties(props, _excluded);
  var _useTabsContext = useTabsContext(),
    tabVariant = _useTabsContext.variant;
  return /*#__PURE__*/React.createElement(BoxPrivate, _extends({
    as: "span",
    ref: ref,
    variant: tabVariant ? "".concat(tabVariant, ".").concat(variant) : variant,
    __themeKey: TAB_THEME_KEY,
    className: classNames({
      'csg-tui-tab-indicator': true,
      'is-vertical': orientation === 'vertical'
    }, className)
  }, other, {
    __css: {
      position: 'absolute',
      transition: disableAnimation ? 'initial' : transitions.create(),
      backgroundColor: backgroundColor,
      height: height,
      width: width,
      transform: 'translateY(-50%) rotate(-135deg)'
    }
  }));
});

export default ArrowIndicator;
//# sourceMappingURL=arrow-indicator.esm.js.map
